import React from 'react';

export default function TermsOfService() {
  return (
    <div style={s.page}>
      <nav style={s.nav}>
        <a href="/" style={s.logo}>CryptoFolio <span style={s.accent}>CFO</span></a>
      </nav>
      <div style={s.content}>
        <h1 style={s.title}>Terms of Service</h1>
        <p style={s.updated}>Last updated: May 23, 2026</p>

        <div style={s.section}>
          <h2 style={s.h2}>1. Acceptance of terms</h2>
          <p style={s.p}>By accessing or using CryptoFolio CFO at xrprightnow.com you agree to be bound by these Terms of Service. If you do not agree, please do not use the Service.</p>
        </div>

        <div style={s.section}>
          <h2 style={s.h2}>2. Not financial, tax, or legal advice</h2>
          <p style={s.p}><strong>IMPORTANT: CryptoFolio CFO is not a registered investment advisor, tax professional, or licensed attorney. Nothing on this platform constitutes financial, investment, tax, or legal advice of any kind.</strong></p>
          <p style={s.p}>All calculations, projections, estimates, and responses generated by the Service are for informational and educational purposes only. They are based on simplified models and may not reflect your actual tax liability, financial situation, or legal obligations.</p>
          <p style={s.p}>You should always consult with a licensed CPA, tax attorney, or qualified financial advisor before making any financial decisions, including but not limited to: selling or purchasing cryptocurrency, forming a business entity, or modifying your tax strategy.</p>
        </div>

        <div style={s.section}>
          <h2 style={s.h2}>3. Intelligent advisor feature</h2>
          <p style={s.p}>CryptoFolio CFO includes an intelligent financial planning feature that generates personalized insights based on your portfolio data. All responses from this feature are for educational and informational purposes only. They may contain errors, omissions, or outdated information and should not be relied upon as professional advice. Always verify information with a qualified professional before taking action.</p>
        </div>

        <div style={s.section}>
          <h2 style={s.h2}>4. Subscription and billing</h2>
          <p style={s.p}>The Pro plan is billed at $27/month following a 7-day free trial. Your payment method will be charged automatically at the end of the trial period unless you cancel before the trial ends. Subscriptions renew automatically each month until cancelled. Cancellation takes effect at the end of your current billing period and you retain access until that date.</p>
          <p style={s.p}>We reserve the right to modify pricing with 30 days notice to existing subscribers. Refund requests may be submitted to xrprightnow@gmail.com and are handled at our discretion.</p>
        </div>

        <div style={s.section}>
          <h2 style={s.h2}>5. Cryptocurrency risk disclosure</h2>
          <p style={s.p}>Cryptocurrency investments are highly speculative and subject to extreme volatility. Past performance does not guarantee future results. You may lose some or all of your investment. CryptoFolio CFO does not recommend the purchase, sale, or holding of any specific cryptocurrency or digital asset.</p>
        </div>

        <div style={s.section}>
          <h2 style={s.h2}>6. Accuracy of information</h2>
          <p style={s.p}>We make reasonable efforts to provide accurate and current information, but we do not warrant the accuracy, completeness, or timeliness of any data on the Service. Price data is sourced from third-party providers and may be delayed, incomplete, or inaccurate. Tax and financial calculations are estimates based on simplified assumptions and do not account for all variables in your individual situation.</p>
        </div>

        <div style={s.section}>
          <h2 style={s.h2}>7. User accounts</h2>
          <p style={s.p}>You must provide accurate information when creating an account and must be at least 18 years of age. You are solely responsible for maintaining the security of your login credentials and for all activity that occurs under your account. Notify us immediately of any unauthorized access at xrprightnow@gmail.com.</p>
        </div>

        <div style={s.section}>
          <h2 style={s.h2}>8. Prohibited uses</h2>
          <p style={s.p}>You may not use the Service to violate any applicable law, attempt unauthorized access to any part of the Service, reverse engineer or copy the platform, use automated tools to extract data, or share your account credentials with others.</p>
        </div>

        <div style={s.section}>
          <h2 style={s.h2}>9. Limitation of liability</h2>
          <p style={s.p}>TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, CRYPTOFOLIO CFO, ITS OWNERS, OPERATORS, EMPLOYEES, AND AFFILIATES SHALL NOT BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES WHATSOEVER, INCLUDING BUT NOT LIMITED TO LOSS OF PROFITS, LOSS OF DATA, OR FINANCIAL LOSSES ARISING FROM YOUR USE OF THE SERVICE.</p>
          <p style={s.p}>YOU EXPRESSLY AGREE THAT YOUR USE OF THE SERVICE IS AT YOUR SOLE RISK. CRYPTOFOLIO CFO IS NOT RESPONSIBLE FOR ANY FINANCIAL DECISIONS YOU MAKE BASED ON INFORMATION PROVIDED BY THE SERVICE.</p>
          <p style={s.p}>BY USING THIS SERVICE YOU WAIVE ANY RIGHT TO BRING CLAIMS AGAINST CRYPTOFOLIO CFO FOR LOSSES RESULTING FROM YOUR USE OF THE PLATFORM. OUR MAXIMUM AGGREGATE LIABILITY SHALL NOT EXCEED THE AMOUNTS PAID BY YOU IN THE THREE MONTHS PRECEDING ANY CLAIM, OR $10 IF NO PAYMENTS HAVE BEEN MADE.</p>
        </div>

        <div style={s.section}>
          <h2 style={s.h2}>10. Indemnification</h2>
          <p style={s.p}>You agree to indemnify and hold harmless CryptoFolio CFO and its operators from any claims, damages, losses, or expenses arising from your use of the Service or your violation of these Terms.</p>
        </div>

        <div style={s.section}>
          <h2 style={s.h2}>11. Termination</h2>
          <p style={s.p}>We reserve the right to suspend or terminate your account at any time for violation of these Terms. You may delete your account at any time from your account settings.</p>
        </div>

        <div style={s.section}>
          <h2 style={s.h2}>12. Changes to terms</h2>
          <p style={s.p}>We may update these Terms at any time. Continued use of the Service after changes constitutes acceptance. We will notify you of material changes by email.</p>
        </div>

        <div style={s.section}>
          <h2 style={s.h2}>13. Governing law</h2>
          <p style={s.p}>These Terms are governed by the laws of the State of Florida, United States. Any disputes shall be resolved in the courts of Collier County, Florida.</p>
        </div>

        <div style={s.section}>
          <h2 style={s.h2}>14. Contact</h2>
          <p style={s.p}>Email: xrprightnow@gmail.com<br/>Website: xrprightnow.com</p>
        </div>
      </div>
      <footer style={s.footer}>
        <a href="/" style={s.footerLink}>Home</a>
        <a href="/terms" style={s.footerLink}>Terms of Service</a>
        <a href="/privacy" style={s.footerLink}>Privacy Policy</a>
      </footer>
    </div>
  );
}

const s = {
  page: { minHeight:'100vh', background:'#f4f1eb', fontFamily:'system-ui, sans-serif' },
  nav: { background:'#fff', borderBottom:'1px solid rgba(0,0,0,0.08)', padding:'0 2rem', height:'60px', display:'flex', alignItems:'center' },
  logo: { fontFamily:'Georgia, serif', fontSize:'18px', color:'#1a1a1a', textDecoration:'none' },
  accent: { color:'#1a6b4a' },
  content: { maxWidth:'760px', margin:'0 auto', padding:'3rem 2rem' },
  title: { fontSize:'32px', fontWeight:'500', color:'#1a1a1a', marginBottom:'0.5rem' },
  updated: { fontSize:'14px', color:'#9b9b9b', marginBottom:'3rem' },
  section: { marginBottom:'2rem' },
  h2: { fontSize:'18px', fontWeight:'500', color:'#1a1a1a', marginBottom:'0.75rem' },
  p: { fontSize:'15px', color:'#4b4b4b', lineHeight:'1.8', marginBottom:'0.75rem' },
  footer: { borderTop:'1px solid rgba(0,0,0,0.08)', padding:'2rem', display:'flex', justifyContent:'center', gap:'2rem', background:'#fff' },
  footerLink: { fontSize:'14px', color:'#6b6b6b', textDecoration:'none' }
};
